import React, { useState } from "react";
import PageWrapper from "./components/PageWrapper";
import { useFormCtx } from "./FormContext";
import Button from "./components/Button";
import Splash from "./components/Splash";
import * as Const from "./_Const";
import * as Helper from "./_Helper";
import WarningPage from "./components/WarningPage";
import DebugPage from "./components/DebugPage";

function PageWelcome() {
  const { loaded, getPageData, navigateNext, welcomePageState, handleDebug, isDebugMode, storageUid } = useFormCtx();
  const [hidden, setHidden] = useState(true);
  const [hiddenHelp, setHiddenHelp] = useState(true);
  const index = Const.HOME_INDEX;
  const page = getPageData(index);
  const showMainPage = loaded && !welcomePageState?.isClosed && welcomePageState?.isMobileAppRegistrationEnabled && !isDebugMode ? true : false;
  const showClosed = loaded && welcomePageState && welcomePageState.isClosed && welcomePageState.isMobileAppRegistrationEnabled ? true : false;
  const isTerminal = Const.isTerminal();
  const showDebug = isTerminal && isDebugMode;
  const pageCss = isTerminal ? "mt-4 flex flex-col h-[65vh] bg-errora justify-center" : "mt-4 flex flex-col";
  //na terminalu nepoustet PING je to hodne vytezujici procesor20-30% i teplotu protoze to je na teto strance porad
  const buttonCss = isTerminal ? "font-bold text-6xl px-16 rounded-2xl mx-6 h-[60vh] " : "font-bold text-3xl px-16 rounded-2xl mx-6 h-32 ping";
  const textCss = isTerminal ? "text-lg" : "text-sm mt-4";
  return (
    <>
      {!loaded && <Splash />}
      {showDebug && (
        <PageWrapper title="Debug mode" index={index} showAppInfo={true} animate={false}>
          <DebugPage terminal={welcomePageState.terminalUID} uid={Helper.decrypt(storageUid)} keyNumber={welcomePageState.keyNumber} />
        </PageWrapper>
      )}
      {showMainPage && (
        <PageWrapper title={page.title} index={index} showAppInfo={true}>
          <div className={pageCss}>
            <Button title="Registrace do systému" showIcon={false} onClick={() => navigateNext(Const.REG_01)} className={buttonCss} />
          </div>

          <div className="mx-6">
            <p className={`${textCss} text-secondary font-light`}>
              Kliknutím na tlačítko <span className="uppercase font-medium italic">Registrace do systému</span> přejdete na další obrazovku
            </p>
            {!isTerminal && (
              <div>
                <p className="mt-12 text-2xl font-black text-accent-dark">O mobilní aplikaci</p>
                <p className="mt-0 text-lg font-light text-secondary">
                  Tato aplikace zjednodušuje proces registrace do pořadového systému ordinace pomocí mobilního telefonu.
                </p>

                <p className="mt-8 text-xl font-black text-accent-dark" onClick={() => setHidden(!hidden)}>
                  Výhody pro pacienta
                </p>
                {!hidden && (
                  <>
                    <p className="mt-0 text-lg font-light text-secondary">- Rychlost vyplnění registračních údajů</p>
                    <p className="mt-0 text-lg font-light text-secondary">- Není nutné nosit kartičku pojištěnce</p>
                    <p className="mt-0 text-lg font-light text-secondary">
                      - Bezpečně uložené registrační údaje pro příští návštěvu ve Vašem mobilním telefonu
                    </p>
                  </>
                )}
                <button className="text-bold uppercase text-sm mt-1 text-accent-dark" onClick={() => setHidden(!hidden)}>
                  {hidden ? "Více informací" : "Méně informací"}
                </button>

                <p className="mt-8 text-xl font-black text-accent-dark" onClick={() => setHiddenHelp(!hiddenHelp)}>
                  Postup při registraci
                </p>
                {!hiddenHelp && (
                  <>
                    <p className="mt-0 text-lg font-light text-secondary">
                      <span className="font-medium">1.</span> <span className="font-medium italic">Naskenujte QR kód</span> pomocí mobilního telefonu
                      připojeného k internetu <span className="font-medium italic">nebo přiložte telefon k NFC čipu</span> na registračním plakátu v ordinaci
                    </p>
                    <p className="mt-0 text-lg font-light text-secondary">
                      <span className="font-medium">2.</span> <span className="font-medium italic">Klikněte na</span> tlačítko
                      <span className="font-medium italic uppercase"> Registrace do systému</span> na hlavní stránce mobilní aplikace
                    </p>
                    <p className="mt-0 text-lg font-light text-secondary">
                      <span className="font-medium">3.</span> Pomocí tlačítek<span className="font-medium italic"> vyberte Důvod návštěvy</span>
                    </p>
                    <p className="mt-0 text-lg font-light text-secondary">
                      <span className="font-medium">4.</span>
                      <span className="font-medium italic">Vyplňte Vaše osobní údaje</span> potřebné pro registraci (veškerá osobní data se přenášejí a
                      uchovávají šifrovaně)
                    </p>
                    <p className="mt-0 text-lg font-light text-secondary">
                      <span className="font-medium">5.</span>
                      <span className="font-medium italic">Klikněte na</span> tlačítko <span className="font-medium italic">Registrovat</span> a posaďte se v
                      čekárně a čekejte na vyzvání
                    </p>
                  </>
                )}
                <button className="text-bold uppercase text-sm mt-1 text-accent-dark" onClick={() => setHiddenHelp(!hiddenHelp)}>
                  {hiddenHelp ? "Více informací" : "Méně informací"}
                </button>
              </div>
            )}
          </div>
        </PageWrapper>
      )}
      {showClosed && <WarningPage title={welcomePageState.closedTitle} index={index} subtitle={welcomePageState.closedSubTitle} message="Zavřeno" />}
    </>
  );
}

export default PageWelcome;
